import { FC, useMemo } from 'react'

import { TBusinessPriorityStatus } from '../../model/types'
import { Pill } from '../pill/Pill'

interface IBusinessPriorityStatusProps {
  status: TBusinessPriorityStatus
}

export const BusinessPriorityStatus: FC<IBusinessPriorityStatusProps> = ({ status }) => {
  const pillColor = useMemo(() => {
    switch (status) {
      case 'Active':
        return 'green'
      case 'Inactive':
        return 'gray'
      default:
        return 'gray'
    }
  }, [status])

  return <Pill color={pillColor}>{status}</Pill>
}
